<template>
	<div>
		<right-panel :datas="connects" @onClose="onCloseForm" ref="right-panel">
			<div slot="header">
				<translate>Cloud Account Import</translate>
			</div>
			<div slot="content" class="wrapper-padding">
				<el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="demo-ruleForm">
					<el-form-item :label="attrText.cloudPlatform" prop="source" class="select-role">
						<el-select v-model="formData.source" @change="changeCloudPlarform" clearable>
							<el-option :label="attrText.aliyun_zh" value="aliyun"></el-option>
							<el-option :label="attrText.aliyun_cn" value="aliyun_overseas"></el-option>
							<el-option :label="attrText.huawei_zh" value="huaweiyun"></el-option>
							<el-option :label="attrText.huawei_cn" value="huaweiyun_overseas"></el-option>
							<el-option :label="attrText.aws_zh" value="aws"></el-option>
							<el-option :label="attrText.aws_cn" value="aws_overseas"></el-option>
							<el-option :label="attrText.volcengine" value="huoshanyun"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="Access Key" prop="ak" class="fixed-text">
						<el-input v-model="formData.ak" :placeholder="attrText.ak"></el-input>
					</el-form-item>
					<el-form-item label="Access Secret" prop="sk" class="fixed-text">
						<el-input v-model="formData.sk" :placeholder="attrText.sk" type="password" name="newPassword" autocomplete="new-password"></el-input>
					</el-form-item>

					<el-form-item :label="attrText.area" prop="region">
						<el-select v-model="formData.region" clearable :disabled="!formData.source">
							<el-option v-for="region in regions" :key="region.RegionId" :label="$language.current === 'zh_CN' ? region.LocalName : region.LocalNameEn" :value="region.RegionId"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="attrText.scanType" prop="region">
						<el-radio-group v-model="formData.is_shield">
							<el-radio :label="0"><translate>Full Scan</translate></el-radio>
							<el-radio :label="1"><translate>Block Imported IP</translate></el-radio>
						</el-radio-group>
					</el-form-item>

					<el-form-item label=" ">
						<el-button class="scan-btn" v-loading="scanLoading" type="primary" :disabled="!isCanScan" @click="scan()"><translate>Scan</translate></el-button>
					</el-form-item>
				</el-form>

				<div class="table-header">
					<span v-if="$route.query.type == 'ecs'"><translate>Select The Host</translate></span>
					<span v-if="$route.query.type == 'rds'"><translate>Select The Database</translate></span>
					<div class="pull-right">
						<el-select v-model="searchForm.condition" placeholder="userType" class="account-search" @change="initSelect">
							<el-option :label="attrText.instanceName" value="instance_name"></el-option>
							<el-option :label="attrText.instanceId" value="instance_id"></el-option>
							<el-option v-if="$route.query.type == 'ecs'" :label="attrText.os" value="os_type"></el-option>
							<el-option v-if="$route.query.type == 'ecs'" label="VPC ID" value="vpc_id"></el-option>
							<el-option v-if="$route.query.type == 'rds'" :label="attrText.type" value="engine"></el-option>
							<el-option :label="attrText.IPAndAddress" value="ip_address"></el-option>
						</el-select>
						<el-input icon="search" v-model="searchForm.text" class="searchInput" @keyup.enter.native="scan()" :on-icon-click="scan"></el-input>
					</div>
				</div>
				<!-- 主机表格 -->
				<el-table v-if="$route.query.type == 'ecs'" class="instance-table" :data="instanceList" style="width: 100%" max-height="400" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="45" fixed="left"> </el-table-column>
					<el-table-column :label="attrText.instanceIdAndName" width="220">
						<template scope="scope">
							<el-tooltip placement="top" :content="scope.row.instance_name">
								<p class="truncate">{{ scope.row.instance_name }}</p>
							</el-tooltip>

							<el-tooltip placement="top" :content="scope.row.instance_id">
								<p class="truncate">{{ scope.row.instance_id }}</p>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.os" prop="os_type" width="130"> </el-table-column>

					<el-table-column label="VPC ID" prop="vpc_id" width="220"> </el-table-column>

					<el-table-column :label="attrText.IPAndAddress" prop="ip_address" width="150"> </el-table-column>

					<el-table-column :label="attrText.port" prop="port" width="100">
						<template scope="scope">
							<el-input v-model="scope.row.port"></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.userName" width="220">
						<template scope="scope">
							<el-input v-model="scope.row.username" :placeholder="attrText.usernameholder"></el-input>
						</template>
					</el-table-column>
				</el-table>

				<!-- 数据库表格 -->
				<el-table v-if="$route.query.type == 'rds'" class="instance-table" :data="instanceList" style="width: 100%" max-height="400" @selection-change="handleSelectionChange">
					<el-table-column type="selection" width="45" fixed="left"> </el-table-column>
					<el-table-column :label="attrText.instanceIdAndName" width="220">
						<template scope="scope">
							<el-tooltip placement="top" :content="scope.row.instance_name">
								<p class="truncate">{{ scope.row.instance_name }}</p>
							</el-tooltip>

							<el-tooltip placement="top" :content="scope.row.instance_id">
								<p class="truncate">{{ scope.row.instance_id }}</p>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.type" prop="engine" width="130"> </el-table-column>

					<el-table-column :label="attrText.IPAndAddress" prop="ip_address" width="200">
						<template scope="scope">
							<el-tooltip placement="top" :content="scope.row.ip_address">
								<p class="truncate">{{ scope.row.ip_address }}</p>
							</el-tooltip>
						</template>
					</el-table-column>

					<el-table-column :label="attrText.port" prop="port" width="100">
						<template scope="scope">
							<el-input v-model="scope.row.port"></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.dataBase" prop="database" width="150">
						<template scope="scope">
							<el-input v-model="scope.row.database"></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.connectIdentifier" width="170">
						<template scope="scope">
							<el-input v-if="scope.row.engine === 'Oracle'" v-model="scope.row.service_name"></el-input>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.connectIdentifierType" width="150">
						<template scope="scope">
							<el-select v-if="scope.row.engine === 'Oracle'" v-model="scope.row.service_name_type">
								<el-option label="Service Name" value="service_name"></el-option>
								<el-option label="SID" value="sid"></el-option>
							</el-select>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.userName" width="220">
						<template scope="scope">
							<el-input v-model="scope.row.username"></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="attrText.password" width="150">
						<template scope="scope">
							<el-input v-model="scope.row.password" type="password"></el-input>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer">
				<div slot="footer" class="detail-btn">
					<el-button type="primary" :disabled="!isCanImport" @click="onStartImport()" v-loading="importLoading">
						<translate>Import</translate>
					</el-button>
					<el-button @click="$refs['right-panel'].onClose()">
						<translate>Cancel</translate>
					</el-button>
				</div>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
import Utilty from '../../../Utils'
export default {
	name: 'ClusterScanImport',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
			formData: {
				source: '',
				ak: '',
				sk: '',
				region: '',
				is_shield: 0,
			},
			regions: [],
			instanceList: [],
			searchForm: {
				condition: 'instance_name',
				text: '',
			},
			selectedInstances: [],
			importLoading: false,
			isCanImport: false,
			nameOsObj: {
				win32: 'administrator',
				linux: 'root',
			},
			queryTimeout: null,
			scanLoading: false,
			rules: {
				source: [{ required: true, message: this.$gettext('Please select the cloud platform'), trigger: 'change' }],
				ak: [{ required: true, message: this.$gettext('Please input the AK'), trigger: 'blur' }],
				sk: [{ required: true, message: this.$gettext('Please input the SK'), trigger: 'blur' }],
				os: [{ required: true, message: this.$gettext('Please select the os'), trigger: 'change' }],
				port: [
					{ required: true, message: this.$gettext('Please input the port'), trigger: 'change' },
					{
						pattern: /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
						message: this.$gettext('please input the right port'),
						trigger: 'change',
					},
				],
				userName: [{ required: true, message: this.$gettext('Please input the userName'), trigger: 'change' }],
				password: [{ required: true, message: this.$gettext('Please input the password'), trigger: 'change' }],
			},
		}
	},
	created() {
		//  console.log('dc', Object.assign({}, this.formData, {os: 'linux'}))
		console.log(this.currentAccount, 'currentAccount')
	},
	computed: {
		attrText() {
			return this.getTransitionText()
		},
		isCanScan() {
			return this.formData.source && this.formData.ak && this.formData.sk && this.formData.region
		},
		currentAccount() {
			return this.$store.getters.account
		},
	},
	methods: {
		getTransitionText() {
			return {
				os: this.$gettext('OS'),
				port: this.$gettext('Port'),
				userName: this.$gettext('userName'),
				password: this.$gettext('Password'),
				moreUser: this.$gettext('Multiple users with semicolons ‘;’'),
				ak: this.$gettext('Please input the AK'),
				sk: this.$gettext('Please input the SK'),
				type: this.$gettext('Type'),
				cloudPlatform: this.$gettext('Cloud Platform'),
				area: this.$gettext('Area'),
				instanceName: this.$gettext('Instance Name'),
				instanceId: this.$gettext('Instance ID'),
				dataBase: this.$gettext('Database'),
				connectIdentifier: this.$gettext('Service Name / SID'),
				connectIdentifierType: this.$gettext('Connection identifier type'),
				usernameholder: this.$gettext('Available; Split multiple usernames'),
				instanceIdAndName: this.$gettext('Instance Name / Instance ID'),
				IPAndAddress: this.$gettext('IP / Connection Address'),
				aliyun_zh: this.$gettext('Alibaba Cloud(China)'),
				aliyun_cn: this.$gettext('Alibaba Cloud(International)'),
				huawei_zh: this.$gettext('Huawei Cloud(China)'),
				huawei_cn: this.$gettext('Huawei Cloud(International)'),
				aws_zh: this.$gettext('AWS(China)'),
				aws_cn: this.$gettext('AWS(International)'),
				volcengine: this.$gettext('Volcengine'),
				scanType: this.$gettext('Scan Type'),
			}
		},

		// 获取区域
		getRegions() {
			let params = {
				source: this.formData.source,
				language: this.$language.current,
			}
			this.$store
				.dispatch(STORE_CONST.CLUSTER.CLOUD_GET_REGIONS, params)
				.then((res) => {
					console.log(res, 'res')
					this.regions = res
				})
				.catch((err) => {
					console.log(err)
				})
		},

		// 扫描
		scan() {
			if (this.searchForm.condition && this.searchForm.text) {
				this.formData.filter = { key: this.searchForm.condition, value: this.searchForm.text }
			} else {
				delete this.formData.filter
			}
			let params = Object.assign({}, this.formData, { type: this.$route.query.type, project_id: this.connects.default_project_id })
			params.sk = this.encrypt(params.sk, this.currentAccount.id, this.currentAccount.company_id)
			this.scanLoading = true
			this.$store
				.dispatch(STORE_CONST.CLUSTER.SCAN_INSTANCE, params)
				.then((res) => {
					console.log(res, 'res')
					this.instanceList = res

					this.scanLoading = false
					if (res && res.length) {
						this.$notify({
							type: 'success',
							message: this.$gettext('Scan success'),
						})
					} else {
						this.$notify({
							type: 'warning',
							message: this.$gettext('No available instance found'),
						})
					}
				})
				.catch((err) => {
					console.log(err, 'err')

					this.scanLoading = false
				})
		},

		// 导入
		onStartImport() {
			let params = {
				network_id: this.connects.id,
				source: this.formData.source,
				type: this.$route.query.type,
				instances: this.selectedInstances,
			}
			this.importLoading = true

			this.$store
				.dispatch(STORE_CONST.CLUSTER.LOAD_INSTANCE, params)
				.then((res) => {
					this.$emit('callback')
					this.$notify({
						type: 'success',
						message: this.$gettext('Import success'),
					})
					this.importLoading = false
				})
				.catch((err) => {
					this.importLoading = false
				})
		},

		// 关闭扫描导入
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},

		// 切换云平台
		changeCloudPlarform(val) {
			if (!val) return
			this.formData.region = ''
			this.getRegions()
		},

		initSelect() {
			this.searchForm.text = ''
		},

		// 表格多选
		handleSelectionChange(val) {
			console.log(val, 'val')
			this.selectedInstances = val
			if (this.selectedInstances && this.selectedInstances.length) {
				this.isCanImport = true
			} else {
				this.isCanImport = false
			}
		},

		// 加密
		encrypt(string, key, iv) {
			return Utilty.Utils.encryptAesCbc(string, key, iv)
		},
	},
	watch: {
		formData: {
			handler: function (newVal, oldVal) {
				this.$refs['formData'].validate((valid) => {
					this.isCanScan = valid
				})
			},
			deep: true,
		},
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
				console.log(this.connects, 'connects')
				console.log(this.$route.query.type, 'route query type')
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
.scan-btn {
	width: 100%;
}

.table-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	> span {
		font-size: 18px;
		font-weight: 700;
	}
	.pull-right {
		.el-input__inner {
			border-radius: 0;
			height: 32px;
		}
		.account-search {
			width: 100px;
			.el-input__icon {
				font-size: 10px;
				width: 21px;
			}
			.el-input__inner {
				padding-right: 21px;
			}
		}
		.condition-search {
			width: 80px;
			.el-input__icon {
				font-size: 10px;
				width: 21px;
			}
			.el-input__icon + .el-input__inner {
				padding-right: 20px;
				border-right: none;
			}
		}
		.searchInput {
			width: 250px;
		}
	}
}

.instance-table {
	margin-top: 20px;
	.el-table__body-wrapper {
		overflow: auto;
	}
}
.truncate {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// cluster-ak-import.vue?1fa00dfa